interface Props {
	rows: number;
	cols: number;
}

export function TableSkeleton({ rows, cols }: Props) {
	return (
		<>
			{Array.from({ length: rows }, (_, i) => (
				<tr key={i}>
					{Array.from({ length: cols }, (_, j) => (
						<td key={j}>
							<div className='h-4 bg-gray-200 animate-pulse rounded' />
						</td>
					))}
				</tr>
			))}
		</>
	);
}
